import "/__w/1/s/BotFramework-WebChat/packages/component/src/Activity/CodeBlockContent.module_built.css";
const classes = {"code-block-content__title":"w4KLAFG_code-block-content__title","code-block-content__header":"w4KLAFG_code-block-content__header","code-block-content":"w4KLAFG_code-block-content","code-block-content__code-block":"w4KLAFG_code-block-content__code-block"}
export default classes

const _code_block_content__title0 = classes["code-block-content__title"]
export { _code_block_content__title0 as "code-block-content__title" }

const _code_block_content__header0 = classes["code-block-content__header"]
export { _code_block_content__header0 as "code-block-content__header" }

const _code_block_content0 = classes["code-block-content"]
export { _code_block_content0 as "code-block-content" }

const _code_block_content__code_block0 = classes["code-block-content__code-block"]
export { _code_block_content__code_block0 as "code-block-content__code-block" }
